import classnames from "classnames";
import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { LogoutLinkContainer } from "@components/Account/LogoutLink/logoutLink.container";
import { PageLinks } from "@components/General/PageLinks/pageLinks.component";

const LoggedInView = ({ menuItems = [] }: { menuItems: Array<any> }) => {
    return (
        <div className={classnames("sidebar__item", "sidebar__item--lined")}>
            <PageLinks links={menuItems} spread={2} />
            <LogoutLinkContainer
                classes={"d-block py-2 text-decoration-none"}
            />
        </div>
    );
};

const LoggedOutView = ({ profileLink }: { profileLink: string }) => {
    const { t } = useGranite();

    return (
        <div className={classnames("sidebar__item", "sidebar__item--lined")}>
            <a href={profileLink}>{t("sideBar.action.link.login")}</a>
        </div>
    );
};

const AccountLinks = ({
    menuItems,
    isLoggedIn,
    profileLink,
}: {
    menuItems: Array<any>;
    isLoggedIn: boolean;
    profileLink: string;
}) => {
    return isLoggedIn ? (
        <LoggedInView menuItems={menuItems} />
    ) : (
        <LoggedOutView profileLink={profileLink} />
    );
};

export { AccountLinks };
